import {Component, Input, OnInit} from '@angular/core';
import {AvisObject} from "../../../../common/components/form/models/avis-object";
import {ReponseState, ResponseStateInstruction} from "../../../../common/components/form/models";
import {Individu} from "@Common/core/services";
import {SubSink} from "@Common/core/utils/subsink";
import {ResponsesService} from "../../../../common/services/responses/responses.service";
import {ResponseDematValueField,} from "../../../../common/components/form/models/responsevaluedemat.model";
import {UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {AvisEnum} from "../../../../common/services/avis/response-avis.model";

@Component({
  selector: 'app-avis-fiche',
  templateUrl: './avis-fiche.component.html',
  styleUrls: ['./avis-fiche.component.scss']
})
export class AvisFicheComponent implements OnInit {
  @Input() item: any;
  @Input() response_state: ReponseState;
  @Input() individu: Individu;
  @Input() response;
  responseState = ReponseState;
  mode_sollicite = false;
  mode_edition = false;
  avis_obj = <AvisObject>{};
  response_value = <ResponseDematValueField>{};
  subSink = new SubSink();
  avisForm: UntypedFormGroup;
  avisEnum = AvisEnum;
  constructor(private responseService: ResponsesService,
              private formBuilder: UntypedFormBuilder,) { }

  ngOnInit(): void {
    this.avis_obj = this.item.value;
    this._checkIfModeSollicite();
    this._initResponseValueField();
    this._initAvisForm();
    this._checkIfModeEdition();
  }

  private _checkIfModeSollicite(): void {
    this.mode_sollicite = (this?.avis_obj?.sollicite.user_name === this.individu.uid
      && this.response_state === this.responseState.published);
  }

  private _checkIfModeEdition(): void{
    this.mode_edition = this.avis_obj.avis === '';
  }

  private _updateAvis(responseValue: ResponseDematValueField): void{
    this.subSink.sink = this.responseService.updateResponseValueById(responseValue).subscribe((_data) => {
      this.mode_edition = false;
    });
  }

  private _initResponseValueField(): void {
    this.response_value.id = this.item.id;
    this.response_value.field = this.item.field;
    this.response_value.response = this.item.response;
    this.response_value.value = this.item.value;
    this.response_value.file = this.item.file;
  }

  sendAvis(): void {
    if(this.avisForm.get('avis').value !== null){
      this.avis_obj.avis = this.avisEnum.toString(this.avisForm.get('avis').value);
      this.avis_obj.avis_key = this.avisForm.get('avis').value;
      this.avis_obj.avis_observation = this.avisForm.get('avis_observation').value;
      this.response_value.value = this.avis_obj;
      this._updateAvis(this.response_value);
    }
  }

  changeMode(): void {
    this.mode_edition = !this.mode_edition;
  }

  private _initAvisForm() {
    this.avisForm = this.formBuilder.group({
      avis: [this.avis_obj.avis_key, [Validators.required]],
      avis_observation: [this.avis_obj.avis_observation, []],
    });
  }

}
